const language = localStorage.getItem("languageSet") || "CN";
console.log(localStorage.getItem("languageSet"))
console.log(language)
export default {
  language 
};



// WEBPACK FOOTER //
// ./src/global.js